import _ from 'lodash';

import config from 'src/config';
import SEGMENT_EVENTS from 'constants/segmentEvents';
import TABLELIST_TERMS from 'constants/tablelistTerms';

const BOOKING_PAYMENT_TYPES = {
  ADVANCE: 'ADVANCE',
  ADVANCE_DEPOSIT: 'ADVANCE_DEPOSIT',
  VENUE: 'VENUE',
  NONE: 'NONE'
};

function Ctrl($scope, $rootScope, $timeout, $state, $stateParams, $uibModal, jsSdkUser, jsSdkBooking, jsSdkAuth, jsSdkLocalStorage,
  utilsService, jsSdkInventory, loggerService, resizeService, metaTagService, tracking, partnerService, $window, trackingService, modalService) {
  $scope.loading = true;
  $scope.BOOKING_PAYMENT_TYPES = BOOKING_PAYMENT_TYPES;
  $scope.errorMessage = null;

  $scope.submitted = false;
  $scope.completingPurchase = false;

  $scope.updateUserForm = {
    email: '',
    phone: ''
  };

  $rootScope.$on('userUpdated', _updateUserForm);

  $scope.bookingHasConfirmationRequestWithArrivalTime = function() {
    if (!$scope.booking) return false;

    return !!($scope.booking.confirmationRequest && $scope.booking.arrivalTime);
  };

  $scope.loginConfig = {
    startState: 'newUser',
    compactLayout: true,
    completeProfile: false,
    success: function(response) {
      $scope.currentUser = response;
      $scope.updateUserForm.email = $scope.currentUser.email;
      $scope.updateUserForm.phone = $scope.currentUser.phone;

      _updateBooking({
        userId: response.id
      }, function(err, resp) {

        if (err) {
          $scope.errorMessage = utilsService.errorMessage(err);
          loggerService.error(err);
        } else {
          $scope.booking.primaryUser = resp.primaryUser;
          $scope.booking.users = resp.users;
        }
      });
    },
    error: function(resp) {
      $scope.errorMessage = utilsService.errorMessage(resp);
      loggerService.error(resp);
    }
  };

  $scope.customerMarketingOptInChanged = function(newVal) {
    _updateBooking({
      customerMarketingOptIn: newVal
    });
  };

  $scope.arrivalTimes = [];

  $scope.changeArrivalTime = function(arrivalTime) {
    $scope.selectedArrivalTime = arrivalTime;

    if (!arrivalTime) return;

    if (arrivalTime === $scope.booking.arrivalTime) return;

    _updateBooking({
      arrivalTime: arrivalTime
    }, function(err, booking) {
      if (err) return;

      $scope.selectedArrivalTime = booking.arrivalTime;
      $scope.booking.arrivalTime = booking.arrivalTime;
    });
  };

  $scope.isUserValid = function() {
    return (typeof $rootScope.isLoggedIn() !== 'undefined');
  };

  $scope.isPhoneValid = function() {
    return $scope.updateUserForm.phone && $scope.updateUserForm.phone.length > 9;
  };

  $scope.isEmailValid = function() {
    return $scope.updateUserForm.email && $scope.updateUserForm.email.length;
  };

  $scope.setPaymentProfile = function(paymentProfile) {
    $scope.paymentProfile = paymentProfile;
  };

  $scope.checkout = function(form) {
    if ($scope.submitted) {
      return null;
    }

    $scope.submitted = true;

    if (!form.email.$valid || !form.phone.$valid) {
      return null;
    }

    $scope.errorMessage = null;
    $scope.completingPurchase = true;

    if (!$scope.isPhoneValid()) {
      $scope.errorMessage = 'Please enter a valid phone number.';
      $scope.completingPurchase = false;
      return null;
    }

    if (!$scope.isEmailValid()) {
      $scope.errorMessage = 'Please enter a valid email address.';
      $scope.completingPurchase = false;
      return null;
    }

    if (!$scope.paymentProfile && (this.booking.payment !== BOOKING_PAYMENT_TYPES.NONE && this.booking.payment !== BOOKING_PAYMENT_TYPES.VENUE)) {
      $scope.errorMessage = 'Please enter your payment information.';
      $scope.completingPurchase = false;
      return null;
    }

    const userData = {};

    if ($scope.updateUserForm.email && $scope.updateUserForm.email !== $scope.currentUser.email) {
      userData.email = $scope.updateUserForm.email;
    }

    if ($scope.updateUserForm.phone && $scope.updateUserForm.phone !== $scope.currentUser.phone) {
      userData.phone = $scope.updateUserForm.phone;
    }

    return jsSdkUser.updateMe(userData)
      .then(() => {
        return jsSdkBooking.complete($scope.booking.id, {
          paymentProfileId: $scope.paymentProfile ? $scope.paymentProfile.id : null
        });
      })
      .then(response => {
        if ($scope.currentUser) {
          $scope.currentUserBookings = $scope.currentUserBookings || [];
          $scope.currentUserBookings.push(response);
        }

        $scope.submitted = false;

        $state.go('app.receipt', {
          booking: response.id
        });
      })
      .catch(resp => {
        $scope.submitted = false;

        $scope.completingPurchase = false;
        $scope.checkoutResult = 'error';
        $scope.errorMessage = utilsService.errorMessage(resp);
      });
  };

  $scope.showArrivalTime = function() {
    if (!$scope.booking || $scope.booking.skipArrivalTime || $scope.booking.inventoryType === 'TICKET' || $scope.booking.inventoryType === 'COVER') return false;

    const start = _.get($scope.booking, 'arrivalStartTime');
    const end = _.get($scope.booking, 'arrivalEndTime');

    return start && end;
  };

  $scope.signOut = function($event) {
    if ($event) $event.preventDefault();

    $rootScope.logout();

    $window.history.back();
  };

  $scope.showVenueTerms = function($event) {
    if ($event) $event.preventDefault();

    modalService.terms({
      terms: $scope.inventory.termsAndConditions
    });
  };

  $scope.showTablelistTerms = function($event) {
    if ($event) $event.preventDefault();

    modalService.terms({
      terms: TABLELIST_TERMS
    });
  };

  _getBooking();

  _updateUserForm();

  trackingService.trackEvent(SEGMENT_EVENTS.StartedCheckout);

  metaTagService.set({
    title: 'Checkout',
    description: 'Checkout'
  });

  function _defaultArrivalTime() {
    $scope.selectedArrivalTime = $scope.booking.arrivalTime;
  }

  function _updateFormWithUser(user) {
    $scope.updateUserForm.email = user.email;
    $scope.updateUserForm.phone = user.phone;
  }

  function _updateUserForm() {
    if (!jsSdkAuth.isLoggedIn()) return null;

    const user = jsSdkUser.getCurrentUser();

    if (user) return _updateFormWithUser(user);

    return jsSdkUser.me()
      .then(_updateFormWithUser);
  }

  function _updateBooking(options, next = (() => {})) {
    return jsSdkBooking.updateById($scope.booking.id, options)
      .then(resp => {
        next(null, resp);
      });
  }

  function _getBooking() {
    jsSdkBooking.read($stateParams.bookingId)
      .then(response => {
        $scope.booking = response;

        $scope.bookingDateSentence = utilsService.getBookingDateSentence($scope.booking);

        $scope.booking.itemCount = _.reduce(response.items, function(sum, item) {
          return sum + item.quantity;
        }, 0);

        const venueName = _.get(response, 'venue.name', 'this venue');

        $scope.venueMarketingOptInText = _.get(response, 'venue.marketingOptInText', `Yes, I'd like to get occasional marketing emails from ${venueName}`);
        $scope.venueShowMarketingOptIn = _.get(response, 'venue.showMarketingOptIn', false);

        $scope.loading = false;

        if ($scope.booking.status !== 'OPEN') {
          $state.go('app.receipt', {
            booking: response.id
          });
          return;
        }

        _defaultArrivalTime();

        _getInventoryStartTime($scope.booking);

        if (config.NODE_ENV === 'production') {
          const fbqData = {
            content_type: 'product',
            value: $scope.booking.price,
            currency: 'USD',
            content_ids: [
              $scope.booking.venue.id
            ],
            referrer: document.referrer,
            userAgent: navigator.userAgent,
            language: navigator.language
          };

          $window.fbq('init', '1606722376242558');
          $window.fbq('trackSingle', '1606722376242558', 'InitiateCheckout', fbqData);
          $window.fbq('init', '316401409092218');
          $window.fbq('trackSingle', '316401409092218', 'InitiateCheckout', fbqData);

          if ($scope.booking.trackingFacebookPixelId && ($scope.booking.trackingFacebookPixelId !== '1606722376242558' && $scope.booking.trackingFacebookPixelId !== '316401409092218')) {
            $window.fbq('init', $scope.booking.trackingFacebookPixelId);
            $window.fbq('trackSingle', $scope.booking.trackingFacebookPixelId, 'InitiateCheckout', fbqData);
          }
        }
      })
      .catch(error => {
        loggerService.error(error);

        console.log('**ERROR GETTING BOOKING**', error);

        $state.go('app.404');
      });
  }

  function _getInventoryStartTime(booking) {
    jsSdkInventory.readById(booking.inventory)
      .then(function(resp) {
        $scope.inventory = resp;

        if (booking.inventoryType === 'TICKET' || booking.inventoryType === 'COVER') return;

        const start = resp.start;
        const end = resp.end;

        createArrivalTimeOptions(start, end);
      });
  }

  function createArrivalTimeOptions(start, end) {
    if (!start || !end) return;

    for (let i = start; i <= end; i += 900000) {
      $scope.arrivalTimes.push(i);
    }
  }
}

Ctrl.$inject = [
  '$scope',
  '$rootScope',
  '$timeout',
  '$state',
  '$stateParams',
  '$uibModal',
  'jsSdk.user',
  'jsSdk.booking',
  'jsSdk.auth',
  'jsSdk.localstorage',
  'utilsService',
  'jsSdk.inventory',
  'loggerService',
  'resizeService',
  'metaTagService',
  'trackingService',
  'partnerService',
  '$window',
  'trackingService',
  'modalService'
];

export default Ctrl;



// WEBPACK FOOTER //
// ./src/components/checkout/checkoutCtrl.js